import sortBy from 'lodash/sortBy'

interface Match {
  index: number
}

export default function findIndexOfUsedWord(text, word, offset) {
  const regexp = new RegExp(`[\\s^]${word}[\\s.,!?:]`, 'gi')

  //Find all usages of this word in text
  const usages = Array.from(
    text.matchAll(regexp),
    (match: Match, usageIndex) => {
      return {
        usageIndex, //Represents which time this word used in text
        distance: Math.abs(match.index - offset) //How far from place where we clicked
      }
    }
  )

  if (usages.length < 2) {
    //If word used less that 2 times - just take first
    return 0
  }

  //Sort by distance and take smallest (closest)
  return sortBy(usages, 'distance')[0].usageIndex
}
